module.exports = __webpack_public_path__ + "img/99_minutos.0ca59f87.svg";